// extracted by mini-css-extract-plugin
export var footer = "_pl-5";
export var fulfillmentInput = "_pl-0";
export var shipDateInput = "_pl-1";
export var shipmentModal = "_pl-2";
export var shipmentModalContent = "_pl-3";
export var tableContainer = "_pl-4";